<h1 mat-dialog-title>{{ 'Aggiungi collegamento' }}</h1>
<mat-dialog-content>
  <div class="cards-info">
    <p>
      {{ 'Collega un bene con il documento archivistico corrente.' | translate }}
    </p>
  </div>
  <form [formGroup]="relationForm">
    <ui-table
      [rowSelection]="'single'"
      [fields]="fields"
      [pager]="pager$"
      [reload]="reload$"
      [filters]="filters$ | async"
      [itemsPage]="(page$ | async)?.current"
      [itemsPerPage]="(page$ | async)?.limit"
      [selected]="selectedItems"
      (itemsPageChange)="applyChangePageHandler($event)"
      (select)="selectHandler($event)">
      <div tableFilters>
        <ui-filters
          [showFiltersTitle]="false"
          [dialogFilters]="MobileFiltersComponent"
          (action)="applyFilterWithDelayHandler($event)">
          <ng-container [ngSwitch]="data?.type">
            <app-card-oa-filters
              *ngSwitchCase="'oa'"
              #desktopFilter>
            </app-card-oa-filters>
            <app-card-f-filters
              *ngSwitchCase="'f'"
              #desktopFilter>
            </app-card-f-filters>
            <app-card-d-filters
              *ngSwitchCase="'d'"
              #desktopFilter>
            </app-card-d-filters>
            <app-card-mi-filters
              *ngSwitchCase="'mi'"
              #desktopFilter>
            </app-card-mi-filters>
            <app-card-s-filters
              *ngSwitchCase="'s'"
              #desktopFilter>
            </app-card-s-filters>
          </ng-container>
        </ui-filters>
      </div>
    </ui-table>
    <div class="cards-actions">
      <button
        mat-button
        mat-raised-button
        type="button"
        (click)="completeHandler()">
        {{ 'Collega' | translate }}
      </button>
    </div>
  </form>
</mat-dialog-content>
